<!-- AddMsg -->
<template>
<!-- Modal -->
  <Modal id="create_broadcast" :savePromise="add" :prepareFunc="prepare" ref="modal">
    <template #button>
      <el-button data-toggle="modal" data-target="#create_broadcast" type="primary" icon="el-icon-edit" circle></el-button>
    </template>
    <template #content>
      <div class="modal-header text-center">
        <span style="color: #387E1E; font-size: 2rem;">編寫訊息</span>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <!-- content of broadcast message -->
          <form class="form-horizontal">

            <div class="form-group">
              <label for="temp" class="col-md-2 control-label">發送至:</label>
              <div class="col-md-10">
                <div style="display: flex; justify-content: space-between">
                  <div>
                    <el-radio v-model="groupChoose" label="student" value="student" border>班級的所有學生</el-radio>
                    <el-radio v-model="groupChoose" label="specific" value="specific" border>個別學生</el-radio>
                  </div>
                  <div v-show="groupChoose === 'specific'" id="member_list">
                    <!--<div v-for="student in students" :key="student.name" class="form-check" style="padding-left: 10px;">
                      <input class="form-check-input" type="checkbox" name='recipients[]' :value="student.id" style="width: initial;">
                      <span style="padding-left: 5px">{{ `${student.name} (${student.email})` }}</span>
                    </div>-->
                    <el-select
                      v-model="studentList"
                      multiple
                      collapse-tags
                      name='recipients[]'
                      style="width: 200px"
                      placeholder="選擇學生">
                      <el-option
                        v-for="student in students"
                        :key="student.id"
                        :label="`${student.name}`"
                        :value="student.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="temp" class="col-md-2 control-label">標題:</label>
              <div class="col-md-10">
                <input type="text" class="form-control" name="title" placeholder="標題" v-model="title">
              </div>
            </div>
            <div class="form-group">
              <label for="temp" class="col-md-2 control-label">附件:</label>
              <div class="col-md-10">
                <!--  <input type="file" name="file[]" multiple style="display: initial;">-->
                <el-upload
                  id="create_broadcast_files"
                  action="temp"
                  name="file[]"
                  multiple
                  :before-remove="handleRemoveFile"
                  :http-request="handleAddFile"
                  thumbnail-mode
                >
                  <el-button size="small" type="primary">請選擇附件</el-button>
                </el-upload>
              </div>
            </div>

            <div class="form-group">
              <label for="temp" class="col-md-2 control-label">內容:</label>
              <div class="col-md-10">
                <textarea class="form-control" rows="8" name="content" v-model="content"></textarea>
              </div>
            </div>
          </form>
          <!-- save or close -->
          <div style="display: flex; justify-content: space-around;">
              <el-button plain data-dismiss="modal">關閉</el-button>
              <el-button type="primary" class="save-btn" data-dismiss="modal">發送</el-button>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Utility/Modal'
import _ from 'lodash'

export default {
  components: {
    Modal
  },
  props: {
    courseId: Number
  },
  data () {
    return {
      students: [],
      teachers: [],
      studentList: [],
      fileList: [],
      title: '',
      content: '',
      groupChoose: 'student'
    }
  },
  methods: {
    add: async function () {
      var fd = new FormData(this.$refs.modal.form)
      console.log(fd.getAll('recipients[]'))
      console.log(fd.getAll('file[]'))
      if (fd.get('title').length === 0 || fd.get('content').length === 0) {
        alert('空白訊息')
        return false
      }
      try {
        fd.append('course_id', this.courseId)
        fd.append('group', this.groupChoose)
        this.studentList.forEach(element => {
          fd.append('recipients[]', element)
        })
        this.fileList.forEach(element => {
          fd.append('file[]', element)
        })
        await this.$store.dispatch('request', {
          method: 'post',
          route: `announcements`,
          data: fd
        })
        alert('已經送出')
        this.studentList = []
        this.fileList = []
        this.$parent.fetchMsg()
        return true
      } catch (err) {
        console.log(err)
        alert('傳送失敗，請稍後再試')
        return false
      }
    },
    prepare: function () {
      this.title = ''
      this.content = ''
      this.groupChoose = 'student'
      document.getElementById('create_broadcast_files').value = ''
    },
    handleAddFile: function (file) {
      this.fileList.push(file.file)
    },
    handleRemoveFile: function (file, fileList) {
      this.fileList = this.fileList.filter(item => !_.isEqual(item, file.raw))
      return true
    }
  },
  mounted: function () {
    try {
      this.$store.dispatch('request', {
        route: `courses/${this.courseId}/members`
      }).then(res => {
        let users = res.sort((a, b) => {
          let nameA = a.name.toUpperCase()
          let nameB = b.name.toUpperCase()
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }
          return 0
        })
        for (let user of users) {
          if (user.role === 'teacher') {
            this.teachers.push(user)
          } else if (user.role === 'student') {
            this.students.push(user)
          }
        }
      })
    } catch (err) {
      console.log(err)
      alert('更新失敗')
    }
  }
}
</script>
